import { render, staticRenderFns } from "./TableSafeguard.vue?vue&type=template&id=13564e68&scoped=true&"
import script from "./TableSafeguard.vue?vue&type=script&lang=js&"
export * from "./TableSafeguard.vue?vue&type=script&lang=js&"
import style0 from "./TableSafeguard.vue?vue&type=style&index=0&id=13564e68&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13564e68",
  null
  
)

export default component.exports